// // // // src/components/patientlist/PatientTable.tsx
// // import React from 'react';
// // import '../../css/PatientTable.css';
// // import { Patient } from '../../types';
// // import { Link } from 'react-router-dom';
// // import { useAuth } from '../../context/AuthContext';

// // interface PatientTableProps {
// //   patients: Patient[];
// //   loading: boolean;
// //   currentPage: number;
// //   itemsPerPage: number;
// // }

// // const PatientTable: React.FC<PatientTableProps> = ({ patients, loading, currentPage, itemsPerPage }) => {
// //   const { doctor } = useAuth();

// //   if (loading) {
// //     return <div className="loading-state">Loading patients...</div>;
// //   }

// //   // ✅ choose route by roleKey (backend) OR type (frontend)
// //   const getPatientUrl = (emrNumber: string) => {
// //     const roleKey = (doctor as any)?.roleKey ? String((doctor as any).roleKey).trim().toLowerCase() : "";
// //     const type = doctor?.type?.trim();

// //     // --- PRIMARY: backend roleKey ---
// //     if (roleKey) {
// //       if (roleKey === "teledoctor" || roleKey === "tele_dental") {
// //         return `/patient/${emrNumber}/charting`;
// //       }
// //       if (roleKey === "pediatric_resident" || roleKey === "pediatric") {
// //         return `/patient/${emrNumber}/pediatric-assessment`;
// //       }
// //       if (roleKey === "dermatologist" || roleKey === "derm") {
// //         return `/patient/${emrNumber}/dermatology-assessment`;
// //       }
// //     }

// //     // --- FALLBACK: old doctor.type ---
// //     if (type === 'Tele Dental') {
// //       return `/patient/${emrNumber}/charting`;
// //     }
// //     if (type === 'Pediatric resident') {
// //       return `/patient/${emrNumber}/pediatric-assessment`;
// //     }
// //     if (type === 'Dermatologist') {
// //       return `/patient/${emrNumber}/dermatology-assessment`;
// //     }

// //     // ✅ last fallback (avoid unauthorized)
// //     return `/patient/${emrNumber}/charting`;
// //   };

// //   return (
// //     <div className="table-container">
// //       <table>
// //         <thead>
// //           <tr>
// //             <th>Sl No.</th>
// //             <th>EMR Number</th>
// //             <th>Screening Date</th>
// //             <th>Age in Queue</th>
// //             <th>Action</th>
// //           </tr>
// //         </thead>

// //         <tbody>
// //           {patients.map((patient, index) => {
// //             const patientUrl = getPatientUrl(patient.emrNumber);

// //             return (
// //               <tr key={patient.id}>
// //                 <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
// //                 <td>{patient.emrNumber}</td>
// //                 <td>{patient.screeningDate}</td>
// //                 <td>{patient.ageInQueue} mins</td>
// //                 <td>
// //                   <Link to={patientUrl} className="action-link">
// //                     Click to view
// //                   </Link>
// //                 </td>
// //               </tr>
// //             );
// //           })}
// //         </tbody>

// //       </table>
// //     </div>
// //   );
// // };

// // export default PatientTable;

// // // src/components/patientlist/PatientTable.tsx
// // import React from 'react';
// // import '../../css/PatientTable.css';
// // import { Patient } from '../../types';
// // import { Link } from 'react-router-dom';
// // import { useAuth } from '../../context/AuthContext';

// // interface PatientTableProps {
// //   patients: Patient[];
// //   loading: boolean;
// //   currentPage: number;
// //   itemsPerPage: number;
// // }

// // const PatientTable: React.FC<PatientTableProps> = ({
// //   patients,
// //   loading,
// //   currentPage,
// //   itemsPerPage,
// // }) => {
// //   const { doctor } = useAuth();

// //   if (loading) {
// //     return <div className="loading-state">Loading patients...</div>;
// //   }

// //   /**
// //    * ✅ SINGLE SOURCE OF TRUTH:
// //    * doctor.roleKey (from backend)
// //    * NOT queue source, NOT workflow origin
// //    */
// //   const getPatientUrl = (emrNumber: string) => {
// //     const roleKey = String((doctor as any)?.roleKey || '')
// //       .trim()
// //       .toLowerCase();

// //     const type = doctor?.type?.trim().toLowerCase();

// //     // ==============================
// //     // PRIMARY: backend roleKey
// //     // ==============================
// //     if (roleKey) {
// //       if (
// //         roleKey === 'teledoctor' ||
// //         roleKey === 'tele_dental' ||
// //         roleKey === 'tele_dentist'
// //       ) {
// //         return `/patient/${emrNumber}/charting`;
// //       }

// //       if (
// //         roleKey === 'pediatric_resident' ||
// //         roleKey === 'pediatric'
// //       ) {
// //         return `/patient/${emrNumber}/pediatric-assessment`;
// //       }

// //       if (
// //         roleKey === 'dermatologist' ||
// //         roleKey === 'derm'
// //       ) {
// //         return `/patient/${emrNumber}/dermatology-assessment`;
// //       }
// //     }

// //     // ==============================
// //     // FALLBACK: legacy doctor.type
// //     // ==============================
// //     if (type === 'tele dental') {
// //       return `/patient/${emrNumber}/charting`;
// //     }

// //     if (type === 'pediatric resident') {
// //       return `/patient/${emrNumber}/pediatric-assessment`;
// //     }

// //     if (type === 'dermatologist') {
// //       return `/patient/${emrNumber}/dermatology-assessment`;
// //     }

// //     // ==============================
// //     // LAST SAFE FALLBACK
// //     // ==============================
// //     return `/patient/${emrNumber}/charting`;
// //   };

// //   const handleViewClick = async (patient: Patient) => {
// //   const taskRole =
// //     doctor?.type === "Dermatologist"
// //       ? "DERMATOLOGY"
// //       : "TELE_DENTIST";

// //   try {
// //     await api.CenterworkflowApi.post(
// //       `/postworkflow/cases/${patient.caseId}/tasks/${taskRole}/start`
// //     );
// //   } catch (err: any) {
// //     // 409 = already started → OK
// //     if (err?.response?.status !== 409) {
// //       console.error(`Failed to start ${taskRole} session:`, err);
// //       alert("Unable to start session. Please try again.");
// //       return;
// //     }
// //   }

// //   // Navigate
// //   if (doctor?.type === "Tele Dental") {
// //     navigate(`/patient/${patient.emrNumber}/charting`, {
// //       state: { caseId: patient.caseId },
// //     });
// //   } else if (doctor?.type === "Pediatric resident") {
// //     navigate(`/patient/${patient.emrNumber}/pediatric-assessment`);
// //   } else if (doctor?.type === "Dermatologist") {
// //     navigate(`/patient/${patient.emrNumber}/dermatology-assessment`, {
// //       state: { caseId: patient.caseId },
// //     });
// //   }
// // };

// //   return (
// //     <div className="table-container">
// //       <table>
// //         <thead>
// //           <tr>
// //             <th>Sl No.</th>
// //             <th>EMR Number</th>
// //             <th>Screening Date</th>
// //             <th>Age in Queue</th>
// //             <th>Action</th>
// //           </tr>
// //         </thead>

// //         <tbody>
// //           {patients.map((patient, index) => {
// //             const patientUrl = getPatientUrl(patient.emrNumber);

// //             return (
// //               <tr key={patient.id}>
// //                 <td>
// //                   {(currentPage - 1) * itemsPerPage + index + 1}
// //                 </td>
// //                 <td>{patient.emrNumber}</td>
// //                 <td>{patient.screeningDate}</td>
// //                 <td>{patient.ageInQueue} mins</td>
// //                 <td>
// //                   <Link to={patientUrl} className="action-link">
// //                     Click to view
// //                   </Link>
// //                 </td>
// //               </tr>
// //             );
// //           })}
// //         </tbody>
// //       </table>
// //     </div>
// //   );
// // };

// // export default PatientTable;

// // // src/components/patientlist/PatientTable.tsx
// // import React from 'react';
// // import '../../css/PatientTable.css';
// // import { Patient } from '../../types';
// // import { useNavigate } from 'react-router-dom';
// // import { useAuth } from '../../context/AuthContext';
// // import api from '../../api/axiosConfig';

// // interface PatientTableProps {
// //   patients: Patient[];
// //   loading: boolean;
// //   currentPage: number;
// //   itemsPerPage: number;
// // }

// // const PatientTable: React.FC<PatientTableProps> = ({
// //   patients,
// //   loading,
// //   currentPage,
// //   itemsPerPage,
// // }) => {
// //   const { doctor } = useAuth();
// //   const navigate = useNavigate();

// //   if (loading) {
// //     return <div className="loading-state">Loading patients...</div>;
// //   }

// //   /**
// //    * 🔥 START SESSION + NAVIGATE
// //    */
// //   const handleViewClick = async (patient: Patient) => {
// //     const roleKey = String((doctor as any)?.roleKey || '').trim().toUpperCase();

// //     // ---------------------------
// //     // Decide task role
// //     // ---------------------------
// //     let taskRole = 'TELE_DENTIST';

// //     if (roleKey === 'PEDIATRIC_RESIDENT') {
// //       taskRole = 'PEDIATRIC_RESIDENT';
// //     } else if (roleKey === 'DERMATOLOGIST') {
// //       taskRole = 'DERMATOLOGY';
// //     }

// //     // ---------------------------
// //     // Start workflow task
// //     // ---------------------------
// //     try {
// //       await api.CenterworkflowApi.post(
// //         `/postworkflow/cases/${patient.caseId}/tasks/${taskRole}/start`
// //       );
// //     } catch (err: any) {
// //       // 409 = already started → OK
// //       if (err?.response?.status !== 409) {
// //         console.error(`Failed to start ${taskRole} task`, err);
// //         alert('Unable to start session. Please try again.');
// //         return;
// //       }
// //     }

// //     // ---------------------------
// //     // Navigate after task start
// //     // ---------------------------
// //     if (taskRole === 'TELE_DENTIST') {
// //       navigate(`/patient/${patient.emrNumber}/charting`, {
// //         state: { caseId: patient.caseId },
// //       });
// //     }

// //     if (taskRole === 'PEDIATRIC_RESIDENT') {
// //       navigate(`/patient/${patient.emrNumber}/pediatric-assessment`, {
// //         state: { caseId: patient.caseId },
// //       });
// //     }

// //     if (taskRole === 'DERMATOLOGY') {
// //       navigate(`/patient/${patient.emrNumber}/dermatology-assessment`, {
// //         state: { caseId: patient.caseId },
// //       });
// //     }
// //   };

// //   return (
// //     <div className="table-container">
// //       <table>
// //         <thead>
// //           <tr>
// //             <th>Sl No.</th>
// //             <th>EMR Number</th>
// //             <th>Screening Date</th>
// //             <th>Age in Queue</th>
// //             <th>Action</th>
// //           </tr>
// //         </thead>

// //         <tbody>
// //           {patients.map((patient, index) => (
// //             <tr key={patient.id}>
// //               <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
// //               <td>{patient.emrNumber}</td>
// //               <td>{patient.screeningDate}</td>
// //               <td>{patient.ageInQueue} mins</td>
// //               <td>
// //                 <span
// //                   className="action-link"
// //                   style={{ cursor: 'pointer' }}
// //                   onClick={() => handleViewClick(patient)}
// //                 >
// //                   Click to view
// //                 </span>
// //               </td>
// //             </tr>
// //           ))}
// //         </tbody>
// //       </table>
// //     </div>
// //   );
// // };

// // export default PatientTable;

// // src/components/patientlist/PatientTable.tsx
// import React from "react";
// import "../../css/PatientTable.css";
// import { Patient } from "../../types";
// import { Link, useNavigate } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import api from "../../api/axiosConfig";

// interface PatientTableProps {
//   patients: Patient[];
//   loading: boolean;
//   currentPage: number;
//   itemsPerPage: number;
// }

// const PatientTable: React.FC<PatientTableProps> = ({
//   patients,
//   loading,
//   currentPage,
//   itemsPerPage,
// }) => {
//   const { doctor } = useAuth();
//   const navigate = useNavigate();

//   if (loading) {
//     return <div className="loading-state">Loading patients...</div>;
//   }

//   /**
//    * 🔥 START SESSION + NAVIGATE
//    * Task role is derived ONLY from current logged-in user
//    */
//   // const handleViewClick = async (patient: Patient) => {
//   //   // 1️⃣ Normalize role key from backend
//   //   const roleKey = String(
//   //     (doctor as any)?.roleKey ||
//   //       (doctor as any)?.roleAssignments?.[0]?.role?.key ||
//   //       "",
//   //   )
//   //     .trim()
//   //     .toUpperCase();

//   //   // 2️⃣ Map role → workflow task
//   //   let taskRole: string;

//   //   switch (roleKey) {
//   //     case "PEDIATRIC":
//   //     case "PEDIATRIC_RESIDENT":
//   //       taskRole = "PEDIATRIC_RESIDENT";
//   //       break;

//   //     case "DERMATOLOGY":
//   //       taskRole = "DERMATOLOGY";
//   //       break;

//   //     case "TELE_DENTIST":
//   //     default:
//   //       taskRole = "TELE_DENTIST";
//   //       break;
//   //   }

//   //   // 3️⃣ Start workflow task
//   //   try {
//   //     await api.CenterworkflowApi.post(
//   //       `/postworkflow/cases/${patient.caseId}/tasks/${taskRole}/start`,
//   //     );
//   //   } catch (err: any) {
//   //     // 409 = task already started (safe)
//   //     if (err?.response?.status !== 409) {
//   //       console.error(`Failed to start ${taskRole} task`, err);
//   //       alert("Unable to start session. Please try again.");
//   //       return;
//   //     }
//   //   }

//   //   // 4️⃣ Navigate to correct screen
//   //   if (taskRole === "TELE_DENTIST") {
//   //     navigate(`/patient/${patient.emrNumber}/charting`, {
//   //       state: { caseId: patient.caseId },
//   //     });
//   //   } else if (taskRole === "PEDIATRIC_RESIDENT") {
//   //     navigate(`/patient/${patient.emrNumber}/pediatric-assessment`, {
//   //       state: { caseId: patient.caseId },
//   //     });
//   //   } else if (taskRole === "DERMATOLOGY") {
//   //     navigate(`/patient/${patient.emrNumber}/dermatology-assessment`, {
//   //       state: { caseId: patient.caseId },
//   //     });
//   //   }
//   // };






// //   const handleViewClick = async (patient: Patient) => {
// //   const path = window.location.pathname.toLowerCase();

// //   let taskRole = "";
// //   let navigatePath = "";

// //   // PEDIATRIC
// //   if (path.includes("/queue/pediatric")) {
// //     taskRole = "PEDIATRIC_RESIDENT";
// //     navigatePath = `/patient/${patient.emrNumber}/pediatric-assessment`;
// //   }

// //   // DERMATOLOGY
// //   else if (path.includes("/queue/dermatology")) {
// //     taskRole = "DERMATOLOGY";
// //     navigatePath = `/patient/${patient.emrNumber}/dermatology-assessment`;
// //   }

// //   // TELE DENTIST
// //   else if (path.includes("/queue/teledental")) {
// //     taskRole = "TELE_DENTIST";
// //     navigatePath = `/patient/${patient.emrNumber}/charting`;
// //   }

// //   // FINAL REVIEW (NO START API)
// //   else if (path.includes("/queue/tele-final-doctor")) {
// //     navigate(
// //       `/patient/${patient.emrNumber}/final-review`,
// //       { state: { caseId: patient.caseId } }
// //     );
// //     return;
// //   }

// //   else {
// //     alert("Unknown queue route");
// //     return;
// //   }

// //   // Only for queues needing start task
// //   try {
// //     await api.CenterworkflowApi.post(
// //       `/postworkflow/cases/${patient.caseId}/tasks/${taskRole}/start`
// //     );
// //   } catch (err: any) {
// //     if (err?.response?.status !== 409) {
// //       console.error(err);
// //       alert("Unable to start session. Please try again.");
// //       return;
// //     }
// //   }

// //   navigate(navigatePath, {
// //     state: { caseId: patient.caseId },
// //   });
// // };





// const handleViewClick = async (patient: Patient) => {
//   console.log("FULL PATIENT =", patient);
//   console.log("META =", patient.meta); // 🔥 ADD THIS

//   const path = window.location.pathname.toLowerCase();

//   // TELE DENTAL
//   if (path.includes("/queue/teledental")) {
//     // navigate(`/patient/${patient.emrNumber}/charting`, {
//     //   state: { caseId: patient.caseId },
//     // });
//     navigate(`/patient/${patient.emrNumber}/charting`, {
//   state: {
//   caseId: patient.caseId,
//   sessionId: patient.sessionId,
//   meta: patient.meta   // 🔥 ADD THIS
// }
// });
//     return;
//   }

//   // PEDIATRIC
//   if (path.includes("/queue/pediatric")) {
//     // navigate(`/patient/${patient.emrNumber}/pediatric-assessment`, {
//     //   state: { caseId: patient.caseId },
//     // });
//     navigate(`/patient/${patient.emrNumber}/pediatric-assessment`, {
//   state: {
//   caseId: patient.caseId,
//   sessionId: patient.sessionId,
//   meta: patient.meta   // 🔥 ADD THIS
// }
// });
//     return;
//   }

//   // DERMATOLOGY
//   if (path.includes("/queue/dermatology")) {
//     // navigate(`/patient/${patient.emrNumber}/dermatology-assessment`, {
//     //   state: { caseId: patient.caseId },
//     // });

//     navigate(`/patient/${patient.emrNumber}/dermatology-assessment`, {
//   state: {
//     caseId: patient.caseId,
//     sessionId: patient.sessionId,
//     meta: patient.meta   // 🔥 ADD THIS
//   }
// });
//     return;
//   }

//   // FINAL REVIEW
//   if (path.includes("/queue/tele-final-doctor")) {
//     // navigate(`/patient/${patient.emrNumber}/final-review`, {
//     //   state: { caseId: patient.caseId },
//     // });

//     navigate(`/patient/${patient.emrNumber}/final-review`, {
// state: {
//   caseId: patient.caseId,
//   sessionId: patient.sessionId,
//   meta: patient.meta   // 🔥 ADD THIS
// }
// });
//     return;
//   }

//   alert("Unknown queue route");
// };

//   return (
//     <div className="table-container">
//       <table>
//         <thead>
//           <tr>
//             <th>Sl No.</th>
//             <th>EMR Number</th>
//             <th>Screening Date</th>
//             <th>Age in Queue</th>
//             <th>Action</th>
//           </tr>
//         </thead>

//       <tbody>
//   {patients.length === 0 ? (
//     <tr>
//       <td
//         colSpan={5}
//         style={{
//           textAlign: "center",
//           padding: "20px",
//         }}
//       >
//         No patients in queue
//       </td>
//     </tr>
//   ) : (
//     patients.map((patient, index) => (
//       <tr key={patient.id}>
//         <td>
//           {(currentPage - 1) * itemsPerPage +
//             index +
//             1}
//         </td>

//         <td>{patient.emrNumber}</td>

//         <td>{patient.screeningDate}</td>

//         <td>{patient.ageInQueue} mins</td>

//         <td>
//           <button
//             className="action-link"
//             onClick={() =>
//               handleViewClick(patient)
//             }
//           >
//             Click to view
//           </button>
//         </td>
//       </tr>
//     ))
//   )}
// </tbody>
//       </table>
//     </div>
//   );
// };

// export default PatientTable;









import React, {
  useMemo,
  useState,
} from "react";

import "../../css/PatientTable.css";

import {
  Patient,
  QueueClaimReview,
} from "../../types";

import { useNavigate } from "react-router-dom";

import { claimTeleQueueItem } from "../../services/queueClaimService";

interface PatientTableProps {
  patients: Patient[];

  loading: boolean;

  currentPage: number;

  itemsPerPage: number;

  myActiveReview:
    | QueueClaimReview
    | null;

  doctorId: string;

  doctorName: string;

  onQueueRefresh: () => Promise<void> | void;
}

const PatientTable: React.FC<
  PatientTableProps
> = ({
  patients,
  loading,
  currentPage,
  itemsPerPage,
  myActiveReview,
  doctorId,
  doctorName,
  onQueueRefresh,
}) => {
  const navigate =
    useNavigate();

  /**
   * Stores the queue item currently being claimed.
   *
   * Only one claim request can be active at a time.
   */
  const [
    claimingPatientId,
    setClaimingPatientId,
  ] = useState<string | null>(null);

  /**
   * Convert the current URL into the backend queue ID.
   */
  const getQueueId = (): string => {
    const path =
      window.location.pathname.toLowerCase();

    if (
      path.includes(
        "/queue/teledental"
      )
    ) {
      return "DENTIST_Q";
    }

    if (
      path.includes(
        "/queue/pediatric"
      )
    ) {
      return "PEDIATRIC_RESIDENT_Q";
    }

    if (
      path.includes(
        "/queue/dermatology"
      )
    ) {
      return "DERMATOLOGY_Q";
    }

    if (
      path.includes(
        "/queue/tele-final-doctor"
      )
    ) {
      return "FINAL_REVIEW_Q";
    }

    throw new Error(
      "Unknown queue route"
    );
  };

  /**
   * Navigate to the existing patient screen.
   *
   * IMPORTANT:
   *
   * The destination URLs are exactly the existing
   * destinations. The claim feature is inserted
   * BEFORE navigation only.
   */
  const navigateToPatient = (
    patient: Patient,
    claim?: QueueClaimReview | null
  ) => {
    const path =
      window.location.pathname.toLowerCase();

    const sessionId =
      claim?.sessionId ||
      patient.sessionId;

    const caseId =
      claim?.bookingId ||
      patient.caseId;

    const queueItemId =
      claim?.queueItemId ||
      patient.queueItemId ||
      patient.id;

    const queueId =
      claim?.queueId ||
      patient.queueId ||
      getQueueId();

    const claimExpiresAt =
      claim?.claimExpiresAt ||
      patient.claimExpiresAt;

    const navigationState = {
      caseId,

      sessionId,

      meta: claim?.meta ||
        patient.meta,

      queueItemId,

      queueId,

      claimExpiresAt,
    };

    if (
      path.includes(
        "/queue/teledental"
      )
    ) {
      navigate(
        `/patient/${patient.emrNumber}/charting`,
        {
          state:
            navigationState,
        }
      );

      return;
    }

    if (
      path.includes(
        "/queue/pediatric"
      )
    ) {
      navigate(
        `/patient/${patient.emrNumber}/pediatric-assessment`,
        {
          state:
            navigationState,
        }
      );

      return;
    }

    if (
      path.includes(
        "/queue/dermatology"
      )
    ) {
      navigate(
        `/patient/${patient.emrNumber}/dermatology-assessment`,
        {
          state:
            navigationState,
        }
      );

      return;
    }

    if (
      path.includes(
        "/queue/tele-final-doctor"
      )
    ) {
      navigate(
        `/patient/${patient.emrNumber}/final-review`,
        {
          state:
            navigationState,
        }
      );

      return;
    }

    alert(
      "Unknown queue route"
    );
  };

  /**
   * Navigate back to the doctor's already claimed patient.
   */
  const continueActiveReview = () => {
    if (!myActiveReview) {
      return;
    }

    const activePatient: Patient = {
      id:
        myActiveReview.queueItemId,

      queueItemId:
        myActiveReview.queueItemId,

      queueId:
        myActiveReview.queueId,

      caseId:
        myActiveReview.bookingId,

      sessionId:
        myActiveReview.sessionId,

      emrNumber:
        myActiveReview.child?.childId ||
        myActiveReview.child?.emrId ||
        "",

      screeningDate:
        myActiveReview.workflowDate ||
        "",

      ageInQueue: 0,

      claimExpiresAt:
        myActiveReview.claimExpiresAt,

      meta:
        myActiveReview.meta,
    };

    navigateToPatient(
      activePatient,
      myActiveReview
    );
  };

  /**
   * Claim a waiting patient and only navigate
   * after the backend confirms ownership.
   */
  const handleViewClick = async (
    patient: Patient
  ) => {
    /**
     * If this doctor already has a patient,
     * they cannot claim another patient.
     */
    if (
      myActiveReview &&
      myActiveReview.queueItemId !==
        patient.queueItemId &&
      myActiveReview.queueItemId !==
        patient.id
    ) {
      alert(
        "You already have an active child to review. Complete that review before selecting another child."
      );

      return;
    }

    /**
     * If the patient shown is already the doctor's
     * active review, simply continue.
     */
    if (
      myActiveReview &&
      (
        myActiveReview.queueItemId ===
          patient.queueItemId ||
        myActiveReview.queueItemId ===
          patient.id
      )
    ) {
      continueActiveReview();
      return;
    }

    /**
     * Safety checks before calling backend.
     */
    if (!doctorId) {
      alert(
        "Unable to identify the logged-in doctor. Please login again."
      );

      return;
    }

    if (!doctorName.trim()) {
      alert(
        "Doctor name is missing. Please login again."
      );

      return;
    }

    const queueItemId =
      patient.queueItemId ||
      patient.id;

    let queueId: string;

    try {
      queueId =
        patient.queueId ||
        getQueueId();
    } catch (error) {
      console.error(
        "Unable to determine queue:",
        error
      );

      alert(
        "Unable to determine queue."
      );

      return;
    }

    /**
     * Prevent double-clicks.
     */
    if (
      claimingPatientId !== null
    ) {
      return;
    }

    try {
      setClaimingPatientId(
        queueItemId
      );

      console.log(
        "CLAIMING QUEUE ITEM",
        {
          queueId,
          queueItemId,
          doctorId,
          doctorName,
        }
      );

      const response =
        await claimTeleQueueItem(
          queueId,
          queueItemId,
          doctorId,
          doctorName
        );

      console.log(
        "CLAIM RESPONSE",
        response
      );

      /**
       * Different backend wrappers can return the
       * claimed queue item under data / queueItem / item.
       *
       * If no nested item is returned, we still have
       * the patient information needed for navigation.
       */
      const claimedItem =
        response?.data ||
        response?.queueItem ||
        response?.item ||
        null;

      const claimedReview:
        QueueClaimReview = {
        queueItemId:
          claimedItem?.queueItemId ||
          claimedItem?._id ||
          queueItemId,

        queueId:
          claimedItem?.queueId ||
          queueId,

        sessionId:
          claimedItem?.sessionId ||
          patient.sessionId,

        bookingId:
          claimedItem?.bookingId ||
          patient.caseId,

        child:
          claimedItem?.child || {
            childId:
              patient.emrNumber,
          },

        state:
          claimedItem?.state ||
          "IN_PROGRESS",

        claimedBy:
          claimedItem?.claimedBy ||
          doctorId,

        claimedByName:
          claimedItem?.claimedByName ||
          doctorName,

        claimedAt:
          claimedItem?.claimedAt,

        claimExpiresAt:
          claimedItem?.claimExpiresAt,

        workflowDate:
          claimedItem?.workflowDate ||
          patient.screeningDate,

        centerId:
          claimedItem?.centerId,

        meta:
          claimedItem?.meta ||
          patient.meta,
      };

      /**
       * Claim succeeded.
       *
       * Navigate to the EXISTING patient page.
       *
       * Nothing in the assessment workflow is changed.
       */
      navigateToPatient(
        patient,
        claimedReview
      );

      /**
       * Refresh queue after navigation request.
       *
       * This is intentionally non-blocking and does not
       * prevent navigation if refresh fails.
       */
      void onQueueRefresh();
    } catch (error: any) {
      console.error(
        "Failed to claim queue item:",
        error
      );

      const status =
        error?.response?.status;

      const backendCode =
        error?.response?.data?.code;

      const backendMessage =
        error?.response?.data?.message;

      /**
       * Doctor already owns another patient.
       */
      if (
        status === 409 &&
        backendCode ===
          "DOCTOR_HAS_ACTIVE_REVIEW"
      ) {
        alert(
          "You already have an active child to review. Complete that review before selecting another child."
        );

        await onQueueRefresh();

        return;
      }

      /**
       * Another doctor claimed the patient between
       * queue refreshes / button click.
       */
      if (
        status === 409 &&
        backendCode ===
          "CHILD_ALREADY_CLAIMED"
      ) {
        alert(
          "This child is already being reviewed by another doctor."
        );

        await onQueueRefresh();

        return;
      }

      if (
        status === 404 &&
        backendCode ===
          "QUEUE_ITEM_NOT_FOUND"
      ) {
        alert(
          "This child is no longer available in the queue."
        );

        await onQueueRefresh();

        return;
      }

      if (
        status === 400 &&
        backendCode ===
          "INVALID_QUEUE_ITEM_ID"
      ) {
        alert(
          "Invalid queue item."
        );

        return;
      }

      /**
       * If backend gives a useful message, show it.
       * Otherwise use a safe generic message.
       */
      alert(
        backendMessage ||
          "Failed to claim this child. Please try again."
      );

      /**
       * Refresh the queue so the UI immediately reflects
       * whatever the backend currently considers available.
       */
      await onQueueRefresh();
    } finally {
      setClaimingPatientId(
        null
      );
    }
  };

  /**
   * Loading state.
   *
   * Only initial loading reaches here.
   * Polling does not replace the table with this loader.
   */
  if (loading) {
    return (
      <div className="loading-state">
        Loading patients...
      </div>
    );
  }

  return (
    <div className="table-container">
      {myActiveReview && (
        <div
          style={{
            marginBottom: "16px",
            padding: "14px 18px",
            borderRadius: "8px",
            border:
              "1px solid #b7dfc2",
            background:
              "#f0fff4",
            display: "flex",
            alignItems:
              "center",
            justifyContent:
              "space-between",
            gap: "16px",
          }}
        >
          <div>
            <strong>
              Active Review
            </strong>

            <div
              style={{
                marginTop: "4px",
                fontSize: "14px",
              }}
            >
              EMR:{" "}
              {myActiveReview.child
                ?.childId ||
                myActiveReview.child
                  ?.emrId ||
                "Patient"}
            </div>

            {myActiveReview.claimExpiresAt && (
              <div
                style={{
                  marginTop: "3px",
                  fontSize: "12px",
                  color: "#666",
                }}
              >
                {/* Claim expires:{" "}
                {new Date(
                  myActiveReview.claimExpiresAt
                ).toLocaleTimeString()} */}
              </div>
            )}
          </div>

          <button
            type="button"
            className="action-link"
            onClick={
              continueActiveReview
            }
          >
            Continue Active Review
          </button>
        </div>
      )}

      <table>
        <thead>
          <tr>
            <th>Sl No.</th>

            <th>
              EMR Number
            </th>

            <th>
              Screening Date
            </th>

            <th>
              Age in Queue
            </th>

            <th>
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {patients.length === 0 ? (
            <tr>
              <td
                colSpan={5}
                style={{
                  textAlign:
                    "center",
                  padding: "20px",
                }}
              >
                No patients in queue
              </td>
            </tr>
          ) : (
            patients.map(
              (
                patient,
                index
              ) => {
                const queueItemId =
                  patient.queueItemId ||
                  patient.id;

                const isClaiming =
                  claimingPatientId ===
                  queueItemId;

                const isMyActivePatient =
                  Boolean(
                    myActiveReview &&
                    myActiveReview.queueItemId ===
                      queueItemId
                  );

                const hasOtherActiveReview =
                  Boolean(
                    myActiveReview &&
                    !isMyActivePatient
                  );

                return (
                  <tr
                    key={
                      patient.id
                    }
                    style={
                      isMyActivePatient
                        ? {
                            background:
                              "#f0fff4",
                          }
                        : undefined
                    }
                  >
                    <td>
                      {(currentPage -
                        1) *
                        itemsPerPage +
                        index +
                        1}
                    </td>

                    <td>
                      {patient.emrNumber}
                    </td>

                    <td>
                      {
                        patient.screeningDate
                      }
                    </td>

                    <td>
                      {
                        patient.ageInQueue
                      }{" "}
                      mins
                    </td>

                    <td>
                      {isMyActivePatient ? (
                        <button
                          type="button"
                          className="action-link"
                          onClick={
                            continueActiveReview
                          }
                        >
                          Continue Active Review
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="action-link"
                          disabled={
                            isClaiming ||
                            hasOtherActiveReview
                          }
                          onClick={() =>
                            handleViewClick(
                              patient
                            )
                          }
                          style={{
                            opacity:
                              hasOtherActiveReview
                                ? 0.5
                                : 1,

                            cursor:
                              hasOtherActiveReview ||
                              isClaiming
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          {isClaiming
                            ? "Claiming..."
                            : hasOtherActiveReview
                            ? "Complete Active Review First"
                            : "Click to view"}
                        </button>
                      )}
                    </td>
                  </tr>
                );
              }
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PatientTable;